<template>
    <div class="container section-menu-page">
        <div class="section-title-wrap">
            <h2 class="section-title">{{ labels.title }}</h2>
        </div>
        <div>
            <div class="admin-home-card table-corporate-body main-menu-scroll-shell">
                <!-- ===== SPINNER DE CARGA ===== -->
                <div v-if="isLoading" class="table-corporate-loading-state">
                    <div class="table-corporate-empty-card">
                        <div class="modern-spinner">
                            <div class="spinner-ring"></div>
                            <div class="spinner-ring"></div>
                            <div class="spinner-ring"></div>
                        </div>
                        <p class="mt-2 mb-0">Cargando...</p>
                    </div>
                </div>

                <!-- ===== CONTENIDO ===== -->
                <b-container v-else style="padding: 18px 40px 40px; height: 100%;">
                    <!-- Grid de botones en columnas verticales -->
                    <div v-if="visibleSubmenus.length > 0" class="menu-grid">
                        <div
                            v-for="subMenu in visibleSubmenus"
                            :key="subMenu.id || subMenu.ruta"
                            class="menu-grid-item"
                        >
                            <div class="menu-item-wrapper">
                                <button
                                    type="button"
                                    class="md-card admin-menu-card-button"
                                    @click="goToRoute(subMenu)"
                                >
                                    <div>
                                        <div>
                                            <div class="md-title-tarjeta">
                                                <span>{{ subMenu?.nombre }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                                <!-- Descripción fija siempre visible -->
                                <div class="div-description-fixed">
                                    <i class="fas fa-info-circle info-icon"></i>
                                    <span class="description-text">{{ subMenu?.descripcion || subMenu?.nombre }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Si no hay submenús, mostrar opciones por defecto -->
                    <div v-else class="menu-grid">
                        <div
                            v-for="item in defaultItems"
                            :key="item.id"
                            class="menu-grid-item"
                        >
                            <div class="menu-item-wrapper">
                                <button
                                    type="button"
                                    class="md-card admin-menu-card-button"
                                    @click="goToRoute(item)"
                                >
                                    <div>
                                        <div>
                                            <div class="md-title-tarjeta">
                                                <span>{{ item.nombre }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                                <div class="div-description-fixed">
                                    <i class="fas fa-info-circle info-icon"></i>
                                    <span class="description-text">{{ item.descripcion || item.nombre }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
import Menu from '../../services/Menu'
import SubMenu from '../../services/SubMenu'

export default {
    name: "Parametrizacion",
    data: () => ({
        listaSubMenu: [],
        isLoading: false,
        error: false
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Parametrización",
                    coins: "Monedas",
                    exchangeRates: "Tasas de cambio",
                    tasasPatrimonio: "Patrimonio",
                    tasasPatrimoniod: "Tasas de Cambio del Patrimonio",
                    niif: "NIIF",
                    niifNoControlante: "NIIF No Controlante",
                    niifNoControlanted: "NIIF para Participaciones No Controlantes",
                    gruposIntercos: "Grupos Intercompañías",
                    gruposIntercosd: "Administración de Grupos Intercompañías",
                    chartAccounts: "Plan de cuentas",
                    schemes: "Esquemas",
                    company: "Compañías",
                    levels: "EFE Directo",
                    levelsDirectEfe: "Consolidacion EFE Método Directo",
                    indirectLevel: "EFE Indirecto",
                    levelIndirectEfe: "Consolidacion EFE Método Indirecto",
                    reporteECP: "ECP",
                    reporteECPd: "Configuración de Reportes ECP",
                    reporteORI: "ORI",
                    reporteORId: "Configuración de Reportes ORI",
                    ajustes: "Ajustes",
                    ajustesd: "Ajustes de Consolidacion",
                    reclasifica: "Reclasifica",
                    reclasificad: "Reclasificacion de Saldos",
                    periodo: "Periodo",
                    periodod: "Administración de Periodos",
                    redefinicionfilas: "Redefinición de Filas",
                    redefinicionfilasd: "Redefinición de Filas y Columnas",
                    nivelesAdmIndirecto: "Niveles Adm Indirecto",
                    nivelesAdmIndirectod: "Administración de Niveles - Método Indirecto",
                    tasasKardex: "Tasas Kardex",
                    tasasKardexd: "Administración de Tasas Kardex",
                    error: "Error al cargar las opciones"
                }
            } else {
                return {
                    title: "Parametrization",
                    coins: "Coins",
                    exchangeRates: "Exchange rates",
                    tasasPatrimonio: "Heritage",
                    tasasPatrimoniod: "Heritage Exchange Rates",
                    niif: "NIIF",
                    niifNoControlante: "Non-Controlling Interest NIIF",
                    niifNoControlanted: "NIIF for Non-Controlling Interests",
                    gruposIntercos: "Intercompany Groups",
                    gruposIntercosd: "Intercompany Groups Administration",
                    chartAccounts: "Chart of accounts",
                    schemes: "Schemes",
                    company: "Companies",
                    levels: "Direct Method EFE",
                    levelsDirectEfe: "Direct Method EFE Consolidation",
                    indirectLevel: "Indirect Method EFE",
                    levelIndirectEfe: "Indirect Method EFE Consolidation",
                    reporteECP: "ECP Report",
                    reporteECPd: "ECP Reports Configuration",
                    reporteORI: "ORI Report",
                    reporteORId: "ORI Reports Configuration",
                    ajustes: "Adjustments",
                    ajustesd: "Consolidation Adjustments",
                    reclasifica: "Reclassify",
                    reclasificad: "Reclassify Accounting Statement",
                    periodo: "Period",
                    periodod: "Period Administration",
                    redefinicionfilas: "Row Redefinition",
                    redefinicionfilasd: "Row and Column Redefinition",
                    nivelesAdmIndirecto: "Admin Levels Indirect",
                    nivelesAdmIndirectod: "Level Administration - Indirect Method",
                    tasasKardex: "Kardex Rates",
                    tasasKardexd: "Kardex Rates Administration",
                    error: "Error loading options"
                }
            }
        },
        visibleSubmenus() {
            return this.listaSubMenu.length > 0 ? this.listaSubMenu : []
        },
        defaultItems() {
            return [
                {
                    id: "company",
                    nombre: this.labels.company,
                    descripcion: "Administración de compañías",
                    ruta: "/company",
                },
                {
                    id: "schemes",
                    nombre: this.labels.schemes,
                    descripcion: "Esquemas",
                    ruta: "/schemes",
                },
                {
                    id: "redefinicionfilas",
                    nombre: "Redefinición Filas",
                    descripcion: "Redefinición Filas",
                    ruta: "/redefinicionFilas",
                },
                {
                    id: "coins",
                    nombre: this.labels.coins,
                    descripcion: "Administrador de monedas",
                    ruta: "/currency",
                },
                {
                    id: "indirectLevel",
                    nombre: "EFE Indirecto",
                    descripcion: "Estados de Flujos de Efectivo - Indirecto",
                    ruta: "/nivelesadm/indirecto",
                },
                {
                    id: "niifNoControlante",
                    nombre: this.labels.niifNoControlante,
                    descripcion: "NIIF No Controlante",
                    ruta: "/niifNoControlante",
                },
                {
                    id: "exchangeRates",
                    nombre: "Tasas de cambio",
                    descripcion: "Tasas de cambio",
                    ruta: "/tasaCambio",
                },
                {
                    id: "reporteECP",
                    nombre: this.labels.reporteECP,
                    descripcion: "Estados de Cambios en el Patrimonio",
                    ruta: "/ecpreporteadc",
                },
                {
                    id: "gruposIntercos",
                    nombre: "Grupos Intercos",
                    descripcion: "Grupos Intercos",
                    ruta: "/gruposintercos",
                },
                {
                    id: "tasasKardex",
                    nombre: "Kardex",
                    descripcion: "Kardex de Patrimonio",
                    ruta: "/tasasKardex",
                },
                {
                    id: "reporteORI",
                    nombre: this.labels.reporteORI,
                    descripcion: "Estados de Otros Resultados Integrales",
                    ruta: "/oriReporte",
                },
                {
                    id: "niif",
                    nombre: this.labels.niif,
                    descripcion: "NIIF",
                    ruta: "/niif",
                },
                {
                    id: "ajustes",
                    nombre: this.labels.ajustes,
                    descripcion: "Ajustes",
                    ruta: "/ajustesConsol",
                },
                {
                    id: "chartAccounts",
                    nombre: this.labels.chartAccounts,
                    descripcion: "Plan de cuentas",
                    ruta: "/planCuentas",
                },
                {
                    id: "periodo",
                    nombre: "Cierre de Periodo",
                    descripcion: "Bloqueo de Periodos",
                    ruta: "/panelAdminPeriodo",
                },
            ]
        }
    },
    methods: {
        routeExists(path) {
            if (!path) return false
            try {
                const resolved = this.$router.resolve(path)
                return !!resolved.name   // el catch-all no tiene name
            } catch (e) {
                return false
            }
        },

        goToRoute(subMenu) {
            const targetRoute = this.resolveRoute(subMenu)
            if (!targetRoute) return

            if (!this.routeExists(targetRoute)) {
                console.error(`La ruta ${targetRoute} no existe en el router`)
                this.$toast?.error(`La ruta ${targetRoute} no está disponible`)
                return
            }
            this.$router.push(targetRoute)
        },
        resolveRoute(subMenu) {
            const rawPath = String(subMenu?.ruta || "").trim()
            const rawName = String(subMenu?.nombre || "").trim().toLowerCase()
            const normalizedPath = rawPath
                ? (rawPath.startsWith("/") ? rawPath : `/${rawPath}`)
                : ""

            const routeMapByName = {
                monedas: "/currency",
                coins: "/currency",
                "tasas de cambio": "/tasaCambio",
                "exchange rates": "/tasaCambio",
                patrimonio: "/heritage",
                heritage: "/heritage",
                niif: "/niif",
                "niif no controlante": "/niifNoControlante",
                "non-controlling interest niif": "/niifNoControlante",
                "grupos intercompañías": "/gruposintercos",
                "grupos intercompanias": "/gruposintercos",
                "intercompany groups": "/gruposintercos",
                "plan de cuentas": "/planCuentas",
                "plan de cuentas niif": "/planCuentas",
                "chart of accounts": "/planCuentas",
                "chart of account": "/planCuentas",
                chartaccounts: "/planCuentas",
                esquemas: "/planConsolidacion",
                schemes: "/planConsolidacion",
                compañías: "/company",
                compañias: "/company",
                companies: "/company",
                "efe directo": "/levelsDirectEfe",
                "direct method efe": "/levelsDirectEfe",
                "efe indirecto": "/nivelesadm/indirecto",
                "indirect method efe": "/nivelesadm/indirecto",
                "reporte ecp": "/ecpreporteadm",
                "ecp report": "/ecpreporteadm",
                "reporte ecp configuracion": "/ecpreporteadm",
                "reporte ori": "/oriReporte",
                "ori report": "/oriReporte",
                "reporte ori configuracion": "/oriReporte",
                ajustes: "/ajustesConsol",
                adjustments: "/ajustesConsol",
                reclasifica: "/reclasifica",
                reclassify: "/reclasifica",
                periodo: "/panelAdminPeriodo",
                period: "/panelAdminPeriodo",
                "redefinicion filas": "/redefinicionFilas",
                "row redefinition": "/redefinicionFilas",
                redefinicionfilas: "/redefinicionFilas",
                "niveles adm indirecto": "/nivelesadm/indirecto",
                "nivelesadm indirecto": "/nivelesadm/indirecto",
                "niveles adm": "/nivelesadm/indirecto",
                nivelesadm: "/nivelesadm/indirecto",
                "tasas kardex": "/tasasKardex",
                "kardex rates": "/tasasKardex",
                tasaskardex: "/tasasKardex",
                kardex: "/tasasKardex",
                "cierre de periodo": "/panelAdminPeriodo",
                "cierre periodo": "/panelAdminPeriodo",
                "bloqueo de periodos": "/panelAdminPeriodo",
                "redefinición filas": "/redefinicionFilas",
                "grupos intercos": "/gruposintercos",
            }

            // Si la ruta que viene del submenú ya existe en el router (incluye rutas con parámetros), se usa tal cual
            if (this.routeExists(normalizedPath)) {
                return normalizedPath
            }

            // Si no, se intenta resolver por el nombre del submenú
            return routeMapByName[rawName] || normalizedPath || null
        },
        async loadSubmenus() {
            this.isLoading = true
            this.error = false
            
            try {
                const menusResponse = await Menu.getAllMenu()
                const menus = menusResponse?.data?.listMenu || []
                const parametrizacionMenu = menus.find((menu) => {
                    const route = String(menu?.ruta || "").toLowerCase()
                    const name = String(menu?.nombre || "").toLowerCase()
                    return route === "parametrizacion" || route === "/parametrizacion" || name === "parametrizacion"
                })
                const menuId = parametrizacionMenu?.id || 3
                const res = await SubMenu.subMenuByMenuByRol(menuId, this.$store.state.userRole)
                this.listaSubMenu = (res?.data?.submenus || []).map((item) => ({
                    ...item,
                    ruta: this.resolveRoute(item),
                }))
            } catch (err) {
                console.error('Error al cargar submenús:', err)
                this.error = true
                this.$toast?.error(this.labels.error || 'Error al cargar las opciones')
            } finally {
                this.isLoading = false
            }
        }
    },
    mounted() {
        this.loadSubmenus()
    },
    beforeDestroy() {
        this.isLoading = false
        this.listaSubMenu = []
    }
}
</script>

<style src="../main.css"></style>
